// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c49b3c5be030333f","3972":"3ed375e49b9b72ae"}[chunkId] + ".css";
};